import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=c8747f52&"
import script from "./AttributeTable.vue?vue&type=script&lang=ts&"
export * from "./AttributeTable.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeTable.vue?vue&type=style&index=0&id=c8747f52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports